import React from 'react';
import { useTheme } from '@mui/material';
import { SystemIcon } from '@monorepo/nova-icons';
import { Tooltip, TooltipPlacement } from '../../../../display/tooltip';
import { StyledIconButton } from '../styled';

export interface ViewToggleButtonProps {
  isListView?: boolean;
  onList?: () => void;
}

export const ViewToggleButton: React.FC<ViewToggleButtonProps> = ({
  isListView = false,
  onList,
}) => {
  const theme = useTheme();

  return (
    <Tooltip
      title={isListView ? 'Grid view' : 'List view'}
      placement={TooltipPlacement.Top}
    >
      <StyledIconButton onClick={onList}>
        <SystemIcon
          iconName={isListView ? 'SquaresFour' : 'List'}
          style={{
            color: theme.palette.text.main,
            fontSize: '18px',
          }}
        />
      </StyledIconButton>
    </Tooltip>
  );
};
